import React, { useState } from 'react';
import { Modal, Input, App } from 'antd';
import { Ruler } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CalibrationDialogProps {
  visible: boolean;
  pixelLength: number;
  onConfirm: (realLength: number) => void;
  onCancel: () => void;
}

const CalibrationDialog: React.FC<CalibrationDialogProps> = ({
  visible,
  pixelLength,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [realLength, setRealLength] = useState<string>('');
  const { message } = App.useApp();

  const handleConfirm = () => {
    const length = parseFloat(realLength);
    
    if (!realLength || isNaN(length) || length <= 0) {
      message.warning('请输入有效的长度值');
      return;
    }
    
    onConfirm(length);
    setRealLength('');
  };

  const handleCancel = () => {
    setRealLength('');
    onCancel();
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <Ruler size={20} className="text-primary-600" />
          <span>{t('calibration.title')}</span>
        </div>
      }
      open={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      okText={t('calibration.confirm')}
      cancelText={t('calibration.cancel')}
      width={450}
    >
      <div className="space-y-4 py-4">
        <div className="bg-primary-50 p-3 rounded-lg">
          <p className="text-sm text-gray-700 mb-2">
            {t('calibration.measured')}
          </p>
          <p className="text-xs text-gray-500">
            {t('calibration.measuredLength', { n: pixelLength.toFixed(2) })}
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('calibration.enterReal')}
          </label>
          <Input
            size="middle"
            type="number"
            value={realLength}
            onChange={(e) => setRealLength(e.target.value)}
            placeholder={t('calibration.placeholder')}
            suffix="cm"
            autoFocus
            onPressEnter={handleConfirm}
          />
          <p className="text-xs text-gray-500 mt-2">
            {t('calibration.tip')}
          </p>
        </div>

        <div className="bg-amber-50 p-3 rounded-lg">
          <p className="text-xs text-gray-600">
            {t('calibration.warning')}
          </p>
        </div>

        <div className="bg-red-50 p-3 rounded-lg border border-red-200">
          <p className="text-xs text-red-700 font-medium">
            {t('calibration.cancelWarning')}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default CalibrationDialog;
